export default __webpack_public_path__ + "static/tile-2-bg-c13941eabc7c6c52653dde087188f4ac.jpg";